import * as React from "react"

function SvgCheckBoxUncheckV2(props) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" y="0.5" width="17" height="17" rx="2.5" stroke="#3B99FC" />
    </svg>
  )
}

export default SvgCheckBoxUncheckV2
